/**
 * Applicant design system: pill radio row (replaces long native <select> for small option sets).
 *
 * @param {{
 *   legend: string,
 *   name: string,
 *   value: string,
 *   onChange: (next: string) => void,
 *   options: { value: string, label: string, secondary?: string }[],
 * }} props
 */
export default function PillRadioFieldset({ legend, name, value, onChange, options }) {
  const safeOptions = Array.isArray(options) && options.length ? options : [];

  return (
    <fieldset className="jw-applicant-pill-fieldset">
      <legend className="jw-applicant-pill-fieldset__legend">{legend}</legend>
      <div className="jw-applicant-pill-fieldset__row">
        {safeOptions.map((opt) => {
          const selected = value === opt.value;
          return (
            <label
              key={`${name}-${opt.value === "" ? "any" : opt.value}`}
              className={`jw-applicant-pill-fieldset__pill${selected ? " jw-applicant-pill-fieldset__pill--selected" : ""}`}
            >
              <input
                type="radio"
                name={name}
                value={opt.value}
                checked={selected}
                onChange={() => onChange(opt.value)}
                className="jw-applicant-pill-fieldset__input"
              />
              <span className="jw-applicant-pill-fieldset__face">
                <span className="jw-applicant-pill-fieldset__primary">{opt.label}</span>
                {opt.secondary ? (
                  <span className="jw-applicant-pill-fieldset__secondary">{opt.secondary}</span>
                ) : null}
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
